c<template>
  <div>
    <h3>
      <span>
        {{ $t('message.script_' + $route.params.menu + '_' + $route.params.script_name) | title }}
      </span>
      <span v-if="docLink" class="wiki-link">
        <a :href="docLink" target="_blank">WIKI</a>
      </span>
    </h3>

    <div v-if="willRunOnEachClusterNode" class="cluster-info">
      {{ $t('message.will_run_on_each_cluster_node') | title }}
    </div>
    <div v-if="willRunOnThisClusterNodeOnly && $route.params.script_name!='database_restore'" class="cluster-info">
      {{ $t('message.will_run_on_this_cluster_node_only') | title }}
    </div>

    <div v-if="description" class="description">{{description}}</div>

    <div v-if="willRunOnThisClusterNodeOnly && $route.params.script_name == 'passman_syslog'">
         {{ $t('message.script_logs_passman_syslog_desc_cluster') }}
    </div>

    <b-form enctype="multipart/form-data" align-h="center">
      <b-form-row v-for="(param, paramName) in params" v-bind:key="paramName"
        v-if="!param.enabled_by || param.enabled_by_values.includes(params[param.enabled_by].value)">
        <label v-if="filenameOptions || (param.type != 'dump_filename' && param.type != 'archive_log_filename')"
          class="label label-default col-3">
          <span v-if="param.displayName">
            {{param.displayName | title}}
          </span>
          <span v-else>
            {{paramName | title}}
          </span>
        </label>
        <span class="col">
          <b-form-input v-if="param.type=='string' || param.type=='filename_postfix' || param.type=='domain_pattern' || param.type=='country_code'"
            v-model="param.value" :placeholder="sensitiveFields.includes(paramName) ? $t('message.none_or_no_change') : ''"/>
          <b-form-input v-if="param.type=='time_of_day'" v-model="param.value"
              :required="true" placeholder="HH:mm" class="col-3"/>
          <b-form-input v-if="param.type=='password'" v-model="param.value" type="password"
            :required="true" autocomplete="new-password"/>
          <b-form-input v-if="param.type=='email'" v-model="param.value" type="email"
            :required="true"/>
          <b-form-input v-if="param.type=='int'" v-model="param.value"
            type="number" :required="true"/>
          <span v-if="param.type=='log_level'">
            <b-form-input  v-model="param.value" type="range" :required="true" :min="0" :max="99"/>
            {{param.value}}
          </span>
          <span v-if="param.type=='upload_file_size'">
            <b-form-input  v-model="param.value" type="range" :required="true" :min="1" :max="100"/>
            {{param.value}} MB
          </span>
          <span v-if="param.type=='int_mins'">
            <b-form-input v-model="param.value"
              type="range" :required="true" min="1" max="120" class="col-8"/>
            <span class="col-2">
              {{param.value}} {{$t('message.minutes')}}
            </span>
          </span>
          <span v-if="param.type=='int_favicon_update_period'">
            <b-form-input v-model="param.value"
              type="range" :required="true" min="1" max="144" class="col-3"/>
            <span class="col-2">
              {{param.value}} {{$t('message.hours')}}
            </span>
          </span>
          <span v-if="param.type=='int_worker'">
            <b-form-input v-model="param.value"
              type="range" :required="true" min="2" max="16" class="col-8"/>
              <span class="col-2">
                {{param.value}}
              </span>
          </span>
          <b-form-select v-if="param.type=='hour'" v-model="param.value"
              :options="hourOptions" class="col-4"/>
          <b-form-select v-if="param.type=='day10'" v-model="param.value"
              :options="day10Options" class="col-3"/>
          <b-form-input v-if="param.type=='url'" v-model="param.value"
            type="url" :required="true"/>
          <b-form-file v-if="param.type=='upload'" v-model="param.value"
            :state="Boolean(param.value)" :placeholder="$t('message.file_upload_placeholder')"
            :browse-text="$t('message.file_upload_browse_button')" accept=".enc, .crt, .key, .cer, .pem"
            @change="clearState"/>
          <b-form-textarea v-if="param.type=='text'" v-model="param.value"
            :rows="7" :required="true" :placeholder="sensitiveFields.includes(paramName) ? $t('message.none_or_no_change') : ''"/>
          <div v-if="param.type=='bool' || param.type=='bool_int'" class="col-1 form-group form-check">
            <input type="checkbox" class="form-check-input" v-model="param.value"/>
          </div>
          <div v-if="param.type=='lang_list'">
            <b-form-row v-for="lang in langOptions">
              <span class="col-4"> {{lang.text}} </span>
              <span class="col-2 form-group form-check">
                <input type="checkbox" :id="lang.value" class="form-check-input" :value="lang.value"
                v-model="param.value"/>
              </span>
            </b-form-row>
          </div>
          <b-form-select v-if="filenameOptions != null && (param.type=='dump_filename' || param.type == 'archive_log_filename')"
            v-model="param.value" :options="filenameOptions" :multiple="param.multiple"/>
          <b-form-select v-if="param.type=='use_scb_options'" v-model="param.value"
            :options="useScbOptions"/>
          <b-form-select v-if="param.type=='sm_container_options'" v-model="param.value"
            :options="smContainerOptions" class="col-4"/>
          <b-form-select v-if="param.type=='backup_download_upload'" v-model="param.value"
            :options="backupDownloadUploadOptions" @change="loadFilenameOptions"/>
          <b-form-select v-if="param.type=='deny_accept_options'" v-model="param.value"
            :options="denyAcceptOptions" class="col-4"/>
          <b-form-select v-if="param.type=='swap_size' && swapSizeOptions" v-model="param.value"
            :options='swapSizeOptions' class='col-2'/>
          <date-picker v-if="param.type=='datetime'" v-model="param.value"
            :config="datePickerOptions" class="col-6"></date-picker>
          <tags-input v-if="param.type=='domain_pattern_list'" v-model="param.value" placeholder=""
            :add-tags-on-comma="true" :typeahead="false" :add-tags-on-blur="true"/>
          <b-form-input v-if="param.type=='cluster_ssh_port'" v-model="param.value"
            type="number" :required="true" min="1"/>
          <b-form-select v-if="param.type=='volume_name'" v-model="param.value"
            :options="volumeNameOptions" class="col-4"/>
          <b-form-select v-if="param.type=='volume_size'" v-model="param.value"
            :options="volumeSizeOptions" class="col-2"/>
          <b-form-select v-if="param.type=='file_source'" v-model="param.value"
            :options="fileSourceOptions" class="col-3"/>
          <b-form-select v-if="param.type=='download_public'" v-model="param.value"
            :options="param.file_options" class="col-10"
            :class="{'file-selector-ok': param.value, 'file-selector-nok': !param.value}"/>
        </span>
        <span v-if="param.docLink" class="col-1 wiki-link">
          <a :href="param.docLink" target="_blank">WIKI</a>
        </span>
        <span v-if="param.desc" class="col-6">
          {{param.desc}}
        </span>
      </b-form-row>

      <ActiveUsers v-if="showActiveUsers" :mins="10"/>

      <b-button v-if="$route.params.menu == 'config' && $route.params.script_name != 'config_import' &&
        $route.params.script_name != 'config_export' &&
          $route.params.script_name != 'session_management_extend_datavol'" :disabled="runInProgress"
        class="padmin-button submit-button" @click="runOrConfirm" variant="primary">
        <b-spinner v-if="runInProgress" small type="grow"/>
        {{$t('message.button_save') | title}}
      </b-button>
      <b-button v-else class="padmin-button submit-button" :disabled="runInProgress || downloadInProgress || !saveEnabled"
        @click="runOrConfirm" variant="primary">
        <b-spinner v-if="runInProgress" small type="grow"/>
        {{$t('message.button_run') | title}}
      </b-button>

      <b-form-row v-if="addComment">
        <label class="label label-default col-3">
          {{$t('message.comment') | title}}
        </label>
        <span class="col">
          <b-form-textarea v-model="comment" :rows="3" :required="false" :disabled="runInProgress"/>
        </span>
      </b-form-row>

      <LastUpdateInfo v-if="showLastUpdate" ref="lastUpdate"/>
    </b-form>

    <b-alert v-model="showError" variant="danger" dismissible @dismissed="error=''; showError=false;">
      <div v-html="error"> </div>
      <div v-if="errorRemark"> {{ errorRemark }}</div>
    </b-alert>

    <ConsoleOutput v-if="runInitiated" :result="result" :output="output"
      :uploadPercent="uploadPercent" :downloadPercent="downloadPercent"/>

    <b-modal ref="page-reload-modal" id="page-reload-modal-id" size="sm"
      ok-only :title="$t('message.page_reload_title')" @ok="pageReload" no-close-on-backdrop>
      {{$t('message.page_reload_desc')}}
    </b-modal>

    <b-modal ref="page-reload-reboot-modal" id="page-reload-reboot-modal-id" size="sm"
      ok-only :title="$t('message.page_reload_reboot_title')" @ok="pageReload" no-close-on-backdrop>
      {{$t('message.page_reload_reboot_desc')}}
    </b-modal>

    <b-modal ref="confirmation-modal" id="confirmation-modal-id" size="sm" @ok="run"
      ok-only :title="$t('message.confirmation_title')" no-close-on-backdrop>
    {{$t('message.confirmation_text')}}
    </b-modal>
  </div>
</template>

<script>
import {fromKeyValueToArray, validateTime, validateDomainNamePattern, validateCountryCode,
  validateEmail, validateClusterSshPort, validatePassword, validateAlphanumericWithExtras2} from '../util'
import { get, post, getFreeDiskSpace, getBinary, forceFileDownload, uploadStart, sensitiveFields } from "../http"
import ConsoleOutput from "./ConsoleOutput"
import ActiveUsers from "./ActiveUsers"
import LastUpdateInfo from "./LastUpdateInfo"
import { EventBus } from '../event-bus.js'

export default {
  name: "GeneralScript",

  components: { ConsoleOutput, ActiveUsers, LastUpdateInfo },

  data() {
    return {
      runAsync: false,
      params: {},
      pageReloadRequired: false,
      form: {},
      result: null,
      output: "",
      downloadInProgress: false,
      runInProgress: false,
      runInitiated: false,
      filenameOptions: null,
      error: null,
      errorRemark: null,
      showError: false,
      useScbOptions: ['no', 'yes', 'on target'],
      smContainerOptions: ['guacamole', 'guacd'],
      hourOptions: [...Array(24).keys()],
      day10Options: [...Array(10).keys()],
      denyAcceptOptions: [{value: 'DEFAULT', text: '----'}, {value: 'DENY_STRONGER', text: 'DENY'},
        {value: 'ACCEPT_STRONGER', text: 'ACCEPT'}],
      backupDownloadUploadOptions: ['backup', 'download', 'upload'],
      datePickerOptions: {
          format: 'YYYY.MM.DD HH:mm',
          useCurrent: true,
          collapse: true,
          sideBySide: true,
          icons: {
            up: 'datetimepicker-up',
            down: 'datetimepicker-down',
            previous: 'datetimepicker-prev',
            next: 'datetimepicker-next'
        }
      },
      volumeNameOptions: [{value: 'root', text: 'root'}, {value:'SMdatavol', text: 'Session manager'}],
      volumeSizeOptions: [{value: '1', text: '1GB'}, {value: '2', text: '2GB'},
                            {value: '3', text: '3GB'}, {value: '4', text: '4GB'},
                            {value: '5', text: '5GB'}, {value: 'MAX', text: 'MAX'}],
      uploadPercent: 0,
      downloadPercent: 0,
      swapSizeOptions: null,
      langOptions: [{value:'en', text:'english'}, {value:'hu', text: 'magyar'}],
      showLastUpdate: false,
      addComment: false,
      comment: '',
      currentActLogId: null
    }
  },

  created() {
    window.addEventListener('keydown', this.keyDownHandler)
  },

  destroyed() {
    window.removeEventListener('keydown', this.keyDownHandler)
  },

  mounted() {
    this.clear()
    this.loadFilenameOptions()
    this.loadSwapSizeOptions()
  },

  watch: {
    $route(to, from) {
      this.clear()
      this.loadFilenameOptions()
      this.loadSwapSizeOptions()
    },

    '$i18n.locale': function(newVal, oldVal) {
      this.setParamInfos()
    }
  },

  computed: {
    fileSourceOptions() {
      return [{value: 'upload', text: this.$options.filters.title(this.$t('message.script_update_upload'))},
       {value: 'public', text: this.$options.filters.title(this.$t('message.script_update_public'))}]
    },

    saveEnabled() {
      if (this.params == {}) return true
      for (let field in this.params) {
        if (this.params[field]['type'] != 'bool' && this.params[field]['type'] != 'bool_int' &&
            this.params[field]['type'] != 'deny_accept_options' && !this.params[field]['optional'] &&
            !this.params[field]['value'] && !sensitiveFields.includes(field)) {
          return false
        }
      }
      if (this.$route.params.script_name.startsWith('update')) {
        if (!this.params['file_source']) {
          return false
        }
        if (this.params['file_source']['value'] == 'upload' && !this.params['upload_file']['value']) {
          return false
        }
        if (this.params['file_source']['value'] == 'public' && !this.params['public_file']['value']) {
          return false
        }
      }
      return true
    },

    sensitiveFields() {
      return sensitiveFields
    },

    description() {
      let messageLookup = 'message.script_' + this.$route.params.menu + '_' + this.$route.params.script_name + '_desc'
      let description = this.$t(messageLookup)
      if (description === messageLookup) {
        description = ''
      }

      return description
    },

    docLink() {
      let messageLookup = 'message.script_' + this.$route.params.menu + '_' + this.$route.params.script_name + '_doc_link'
      let docLink = this.$t(messageLookup)
      if (docLink === messageLookup) {
        return ""
      }
      return docLink
    }
  },

  methods: {
    getUrl() {
      return (
        "/scripts/" + this.$route.params.menu + "/" + this.$route.params.script_name
      )
    },

    clear() {
      this.getScriptConfigWithValues()
      this.clearState()
    },

    clearState() {
      this.result = null
      this.output = ""
      this.runInProgress = false
      this.runInitiated = false
      this.downloadInProgress = false
      this.error = null
      this.errorRemark = null
      this.showError = false
      this.uploadPercent = 0
      this.downloadPercent = 0
      this.comment = ''
    },

    keyDownHandler(e) {
      if (e.key == 'Enter') {
        if (['ping', 'nslookup'].includes(this.$route.params.script_name))
        this.runOrConfirm()
      }
    },

    loadFilenameOptions() {
      let url = null
      if (this.$route.params.script_name == 'delete_dump') {
        let folder = 'backup'
        if (this.params && this.params.folder && this.params.folder.value) {
          folder = this.params.folder.value
        }
        url = '/list_dump_filenames?folder=' + folder
      } else if (this.$route.params.script_name == 'archive_logs_download') {
          url = '/list_archive_log_filenames'
      } else {
        this.filenameOptions = null
        return
      }

      get(url).then(resp => {
        if (resp.data.error) {
          this.error = resp.data.error
          console.log(resp.data.error)
        } else {
          this.filenameOptions = resp.data.filenames
        }
      },
      err => {
        console.log(err)
      })
    },

    loadSwapSizeOptions() {
      if (this.$route.params.script_name != 'swap') return

      this.swapSizeOptions = null
      get('/swap_size_options').then(resp => {
        if (resp.data.error) {
          this.error = resp.data.error
          console.log(resp.data.error)
        } else {
          this.swapSizeOptions = resp.data.swap_size_options
          if (this.swapSizeOptions.length) {
            this.params.swap_size.value = resp.data.swap_size_options[0]
          }
        }
      },
      err => {
        console.log(err)
      })
    },

    runOrConfirm() {
      if (this.confirmationNeeded) {
        this.$root.$emit("bv::show::modal", "confirmation-modal-id")
      } else {
        this.run()
      }
    },

    runIfNoParams() {
      if (
        (this.$route.params.menu === "status") &&
        Object.keys(this.params).length === 0
      ) {
        this.run();
      }
    },

    onUploadProgress(progressEvent) {
      this.uploadPercent = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100))
    },

    onDownloadProgress(progressEvent) {
      this.downloadPercent = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100))
    },

    async run() {
      this.result = null
      this.output = ''
      this.error = ''
      this.showError = false
      this.currentActLogId = null

      const formData = new FormData()
      var hasUploadParam = false

      for (let field in this.params) {
        let param = this.params[field]

        if (param.value && param.value.name) {
          let ext = param.value.name.split('.').pop()
          if (param.type == 'upload') {
            if ((this.$route.params.script_name.toLowerCase().includes('passman') && !param.value.name.toLowerCase().includes('passman')) ||
               (this.$route.params.script_name.toLowerCase().includes('padmin') && !param.value.name.toLowerCase().includes('padmin')) ||
               (this.$route.params.script_name.toLowerCase().includes('mongo') && !param.value.name.toLowerCase().includes('passmongo'))) {
                this.error = this.$t('message.error_invalid_file_format')
                this.showError = true
                return
            } else if (ext != 'crt' && ext != 'key' && ext != 'enc' && ext != 'pem' && ext != 'cer') {
              this.error = this.$t('message.error_invalid_file_format')
              this.showError = true
              return
            }
            hasUploadParam = true
          }
          if (param.value && param.value.size) {
            const freeDiskSpaceResp = await getFreeDiskSpace()
            if (freeDiskSpaceResp.error) {
              this.error = freeDiskSpaceResp.error
              this.showError = true
              return
            }
            const fileSize = param.value.size
            const neededSpace = fileSize * 3
            if(neededSpace > freeDiskSpaceResp.free_disk_space) {
              const needMore = Math.ceil((neededSpace - freeDiskSpaceResp.free_disk_space) / 1024 / 1024)
              this.error = this.$t('message.error_not_enough_disk_space') + needMore + ' M'
              this.showError = true
              return
            }
          }
        } else {
          if (param['type'] == 'swap_size' &&
              (!this.swapSizeOptions || param['value'] == this.swapSizeOptions[0])) {
            this.error = 'no change'
            this.showError = true
            return
          }
        }
        if (param.type == 'time_of_day') {
          if (!validateTime(param.value)) {
            this.error = this.$t('message.error_invalid_time') + ': ' + param.value
            this.showError = true
            return
          }
        }
        if (param.type == 'domain_pattern') {
          if (!validateDomainNamePattern(param.value)) {
            this.error = this.$t('message.error_invalid_domain_pattern') + ': ' + param.value
            this.showError = true
            return
          }
        }
        if (param.type == 'domain_pattern_list') {
          let domains = fromKeyValueToArray(param.value)
          for (let domain of domains) {
            if (!validateDomainNamePattern(domain)) {
              this.error = this.$t('message.error_invalid_domain_pattern') + ': ' + domain
              this.showError = true
              return
            }
          }
          formData.append(field, domains)
          continue
        }
        if (param.type == 'country_code') {
          if (!validateCountryCode(param.value)) {
            this.error = this.$t('message.error_invalid_country_code') + ': ' + param.value
            this.showError = true
            return
          }
        }
        if (param.type == 'filename_postfix') {
          if (!validateAlphanumericWithExtras2(param.value)) {
            this.error = this.$t('message.error_invalid_filename_postfix') + ': ' + param.value
            this.showError = true
            return
          }
        }
        if (param.type == 'email') {
          if (!validateEmail(param.value)) {
            this.error = this.$t('message.error_invalid_email') + ': ' + param.value
            this.showError = true
            return
          }
        }
        if (param.type == 'cluster_ssh_port') {
          if (!validateClusterSshPort(param.value)) {
            this.error = this.$t('message.error_invalid_port') + ': ' + param.value
            this.showError = true
            return
          }
        }

        if (param.type == 'password' &&
          (this.$route.params.script_name == 'config_download' || this.$route.params.script_name == 'database_download_full')) {
          let weakPasswdError = validatePassword(param.value)
          if (weakPasswdError) {
            this.error = this.$t('message.error_password_weak') + ': '
              + this.$t('message.error_password_' + weakPasswdError) + '!'
            this.showError = true
            return
          }
        }

        formData.append(field, param.value)
      }

      if (this.addComment) {
        formData.append('comment', this.comment)
      }

      if (hasUploadParam) {
        var uploadStartResp = await uploadStart(this.$route.params.script_name)
        if (!uploadStartResp) {
          // conflict
          return
        }
        formData.append('this_act_log_id', uploadStartResp.act_log_id)
      }

      this.runInitiated = true
      this.runInProgress = true

      post(this.getUrl(), formData, {"content-type": "multipart/form-data"}, this.onUploadProgress).then(
        resp => {
          this.output = resp.data.output
          this.result = resp.data.result
          this.errorRemark = null
          if (resp.data.error) {
            this.showError = true
            this.error = this.$t('message.error_' + resp.data.error)
            if (this.error.startsWith('message')) {
              this.error = this.error.substring(14)
            }
          } else {
            this.error = null
            this.showError = false
          }

          if (this.runAsync) {
            if (resp.data.result && resp.data.command_id) {
              // async save on backend, so check progress for response
              this.loadProgress(resp.data.command_id)
            } else {
              this.runInProgress = false
            }
          } else {
            this.runInProgress = false

            let downloadLinks = resp.data.download_links
            if (downloadLinks) {
              for(let downloadLink of downloadLinks) {
                this.download(downloadLink)
              }
            }

            if (this.result && resp.data.padmin_restart_required) {
              this.$root.$emit("bv::show::modal", "padmin-restart-modal-id")
            }

            if (this.result && resp.data.agung_restart_required) {
              this.$root.$emit("bv::show::modal", "passman-restart-modal-id")
            }

            if (this.result && resp.data.shutdown_required) {
              this.$root.$emit("bv::show::modal", "shutdown-modal-id")
            }

            if (this.result && resp.data.page_reload_required) {
              this.$root.$emit("bv::show::modal", "page-reload-modal-id")
            }

            if (this.result && this.$route.params.script_name == 'supported_languages') {
              EventBus.$emit("load supported languages")
            }

            this.loadFilenameOptions()
            this.loadSwapSizeOptions()

            if (this.$route.params.script_name.includes('update')) {
              this.$refs.lastUpdate.getLastRun()
            }
          }
        },
        err => {
          this.runInProgress = false
          if (this.$route.params.script_name === "shutdown" || this.$route.params.script_name === "shutdown_cluster") {
            return
          }
          if (err.response) {
            if (err.response.status == 409) {
              this.runInitiated = false
              return
            }
            this.error = err.response.data
            if (this.pageReloadRequired && (err.response.status == 502 || err.response.status == 504)) {
              // with reboot, padmin update and restart 502 is normal
              if (this.$route.params.script_name.includes("reboot")) {
                  this.$root.$emit("bv::show::modal", "page-reload-reboot-modal-id")
              } else {
                this.$root.$emit("bv::show::modal", "page-reload-modal-id")
              }
            } else {
              this.showError = true
              if (err.response.status == 504) {
                if (this.padminRestartRequired) {
                  this.errorRemark = this.$t('message.error_timeout_restart_padmin_remark')
                }
                if (this.agungRestartRequired) {
                  this.errorRemark = this.$t('message.error_timeout_restart_agung_remark')
                }
              }
            }
          } else {
            // Network Error, and no response in case of reboot
            if (this.$route.params.script_name.includes("reboot")) {
                this.$root.$emit("bv::show::modal", "page-reload-reboot-modal-id")
            }
          }
        }
      ).catch(err => {
        console.log('exc', err)
      })
    },

    loadProgress (commandId) {
      get('/command_progress/' + commandId).then(resp => {
        this.output = resp.data.output
        this.result = resp.data.result
        this.runInProgress = resp.data.in_progress
        if (this.runInProgress || (this.result != true && this.result != false)) {
          setTimeout(() => {
            this.loadProgress(commandId)
          }, 1000)
        } else {
          if (this.result && this.agungRestartRequired) {
            this.$root.$emit("bv::show::modal", "passman-restart-modal-id")
          }

          if (this.result && this.padminRestartRequired) {
            this.$root.$emit("bv::show::modal", "padmin-restart-modal-id")
          }

          if (this.result && this.pageReloadRequired) {
            this.$root.$emit("bv::show::modal", "page-reload-modal-id")
          }

          this.loadFilenameOptions()
        }
      })
    },

    getScriptConfigWithValues() {
      this.params = {}
      get(this.getUrl()).then(resp => {
        this.params = resp.data.params
        for (let paramName in this.params) {
          let displayName = this.$t('message.script_' + this.$route.params.menu + '_' + this.$route.params.script_name +
            '_param_' + paramName)
          if (!displayName.startsWith('message')) {
            this.params[paramName]['displayName'] = displayName
          }
          if (this.params[paramName].type == 'lang_list') {
            this.params[paramName].value = this.params[paramName].value.split(',')
          }
        }

        this.pageReloadRequired = resp.data.page_reload_required
        this.runAsync = resp.data.run_async
        this.agungRestartRequired = resp.data.agung_restart_required
        this.padminRestartRequired = resp.data.padmin_restart_required
        this.shutdownRequired = resp.data.shutdown_required
        this.confirmationNeeded = resp.data.confirmation_needed
        this.willRunOnEachClusterNode = resp.data.will_run_on_each_cluster_node
        this.willRunOnThisClusterNodeOnly = resp.data.will_run_on_this_cluster_node_only
        this.showActiveUsers = resp.data.show_active_users
        this.showLastUpdate = resp.data.show_last_update
        this.addComment = resp.data.add_comment

        if (!this.confirmationNeeded) {
          this.runIfNoParams()
        }
        this.setParamInfos()
      })
    },

    setParamInfos() {
      for (let paramName in this.params) {
        let displayName = this.$t('message.script_' + this.$route.params.menu + '_' + this.$route.params.script_name +
          '_param_' + paramName)
        if (!displayName.startsWith('message')) {
          this.params[paramName]['displayName'] = displayName
        }
        let desc = this.$t('message.script_' + this.$route.params.menu + '_' + this.$route.params.script_name +
          '_param_' + paramName + '_desc')
        if (!desc.startsWith('message')) {
          this.params[paramName]['desc'] = desc
        }
        let docLink = this.$t('message.script_' + this.$route.params.menu + '_' + this.$route.params.script_name +
          '_param_' + paramName + '_doc_link')
        if (!docLink.startsWith('message')) {
          this.params[paramName]['docLink'] = docLink
        }
      }
    },

    download(downloadLink) {
      this.downloadInProgress = true
      getBinary(downloadLink, this.onDownloadProgress).then(
        resp => {
          let fileName = downloadLink.split("/").slice(-1).pop()
          forceFileDownload(resp.data, fileName)
          this.downloadInProgress = false
        },
        err => {
          console.log("err", err)
          this.error = 'HTTP ERROR:' + err.response.status + ' ' + err.response.statusText
          this.showError = true
          this.downloadInProgress = false
        }
      )
    },

    pageReload() {
      window.location.reload()
    }
  }
}
</script>

<style>
  .datetimepicker-prev:before {
    content: "<<";
  }
  .datetimepicker-next:before {
    content: ">>";
  }
  .datetimepicker-up:before {
    content: "+";
  }
  .datetimepicker-down:before {
    content: "-";
  }
  .description {
    margin-left: 100px;
    margin-right: 100px;
  }
</style>
